export const SUPPORT_EMAIL = "support@hourglass-app.com";
